import { useState, useEffect } from 'react';

/**
 * Hook to detect if the current viewport is desktop-sized (>= 1024px).
 * Uses window.matchMedia for accurate CSS breakpoint matching.
 */
export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(false);
  
  useEffect(() => {
    // Handle SSR
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia('(min-width: 1024px)');
    
    // Set initial value
    setIsDesktop(mediaQuery.matches);
    
    // Modern browsers use addEventListener, older use addListener
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    
    try {
      mediaQuery.addEventListener('change', handler);
      return () => mediaQuery.removeEventListener('change', handler);
    } catch (e) {
      // Fallback for older browsers
      mediaQuery.addListener(handler);
      return () => mediaQuery.removeListener(handler);
    }
  }, []);
  
  return isDesktop;
};

export default useIsDesktop;

